import axios from "axios";
import ConnUrls from '../Connections/ConnectURL';

// טופס ציבורי לפי slug (ללא אימות)
const getBySlug = async (slug) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "forms/pub/bySlug/" + slug);
    return (dFromF);
};

// הגשת תשובה (ללא אימות). body: { clientName, answers }
const submit = async (slug, body) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "forms/pub/submit/" + slug, { ...body, token: null });
    return (dFromF);
};

export default {
    getBySlug,
    submit,
};
